export enum PromocodeUsageStatus {
  Activated = 1,
  Wasted = 2,
}
